import React from 'react';
import './styles.css';
import { FaInstagram, FaFacebookF, FaAt, FaGithub } from 'react-icons/fa';

function Footer(){
    return(
        <>
        <div className="container"></div>
        <footer>
            <section className="ft-social">
                <ul className="ft-social-list">
                    <li><a href="https://m.facebook.com/ufftech.ej" target="_blank"><FaFacebookF/></a></li>
                    <li><a href="https://instagram.com/ufftech" target="_blank"><FaInstagram/></a></li>
                    <li><a href="https://ufftech.com" target="_blank"><FaAt/></a></li>
                    <li><a href="https://github.com/ufftech" target="_blank"><FaGithub/></a></li>
                </ul>
            </section>
            
            <section className="ft-legal">
                <ul className="ft-legal-list">
                    <li><a href="#">Terms &amp; Conditions</a></li>
                    <li><a href="#">Privacy Policy</a></li>
                    <li>&copy; 2020 Copyright UFFTech Junior</li>
                </ul>
            </section>
        </footer>
        </>
    );
}

export default Footer;